import React, { Component } from 'react';
import './liabilities-structure.style.scss';
import { Cell, Label, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import dollar from 'assets/icons/dollar-icon.svg';

function CustomLabel({ viewBox, value }) {
  const { cx, cy } = viewBox;
  return (
    <svg className='recharts-text recharts-label' textAnchor='middle' dominantBaseline='central'>
      <text x={cx} y={cy}>
        <tspan
          x={cx}
          dy='0em'
          alignmentBaseline='middle'
          fontSize='20'
          fill='#0B0B0A'
          fontWeight={600}>
          {value}
        </tspan>
      </text>
    </svg>
  );
}

export default class LiabilitiesStructure extends Component {
  render() {
    const data = [
      { name: 'Deposit', key: 'i', value: 86 },
      { name: 'Valuation Paper', key: 'l', value: 5 },
      { name: 'Equity', key: 'is', value: 6 },
      { name: 'Other', key: 'ot', value: 3 },
    ];
    const COLORS = ['#FDE39B', '#FBC83A', '#C89404', '#644A02'];
    return (
      <div className='liabilities-structure-container'>
        <h1 className='liabilities-structure-title'>
          <img src={dollar} alt='' style={{ marginRight: 8 }} />
          LIABILITIES STRUCTURE
        </h1>
        <ResponsiveContainer width='100%' height={250}>
          <PieChart>
            <Pie
              paddingAngle={0}
              data={data}
              dataKey='value'
              cx='50%'
              cy='50%'
              outerRadius={125}
              innerRadius={85}
              startAngle={90}
              endAngle={-450}>
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                  borderWidth={0}
                  stroke={0}
                />
              ))}
              <Label width={80} position='center' content={<CustomLabel value={'181,438'} />} />
            </Pie>
            <Tooltip content={<CustomTooltip data={data} colors={COLORS} />} />

            <Legend
              layout='vertical'
              align='right'
              verticalAlign='middle'
              formatter={(value, entry) => {
                const { payload } = entry;
                return (
                  <span style={{ color: '#0B0B0A', fontSize: 14 }}>
                    {value}
                    {'  '}
                    <span style={{ color: '#0B0B0A', fontSize: 14, fontWeight: 600 }}>
                      {payload.value}%
                    </span>
                  </span>
                );
              }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    );
  }
}
const CustomTooltip = (props) => {
  const { active, payload, data, colors } = props;

  if (active && payload && payload.length) {
    const item = payload[0].payload;
    const index = data.findIndex((el) => el.key === item.key);

    return (
      <div className='custom-tooltip' style={{ backgroundColor: colors[index % data.length] }}>
        <span className='name'>{item.name}</span>
        <span className='desc'>{item.value}%</span>
      </div>
    );
  }

  return null;
};



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/LiabilitiesStructure/LiabilitiesStructure.js